import './feature-image.css';

/**
 * @param {HTMLElement} element
 *   The <img> element to have the bleed applied.
 */
function CreateBlurImage(element) {
  const blurElement = element.cloneNode(true);
  blurElement.className = 'feature-image__bleed';
  element.parentNode.insertBefore(blurElement, element);
}

export default CreateBlurImage;
